import React, { FC } from 'react'
import Theme from '../../theme'
import { Navbar, Footer } from '../shared'
import GlobalStyles from '../../GlobalStyles'
import styled from 'styled-components'

const SkipLink = styled.a`
  position: absolute;
  top: -100%;
  left: 1rem;
  background: #990000;
  color: white;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  text-decoration: none;
  border-radius: 0 0 4px 4px;
  z-index: 9999;
  &:focus {
    top: 0;
  }
`

// Pins the navbar to the top of the viewport.
const StickyTop = styled.div`
  position: sticky;
  top: 0;
  z-index: 99;
`

const Layout: FC = ({ children }) => {
  return (
    <Theme>
      <GlobalStyles />
      <SkipLink href="#main-content">Skip to main content</SkipLink>
      <StickyTop>
        <header>
          <Navbar />
        </header>
      </StickyTop>
      <main id="main-content">{children}</main>
      <Footer />
    </Theme>
  )
}

export default Layout
